import React from 'react'
import './header.css'

const Header = () => {
    return (
        <div className="header">
            <h1 className="header-text">New albums & singles</h1>
        </div>
    )
}

export default Header